var map = {
	"./01_executionReport.json": "H6dO",
	"./02_ account_update.json": "bZVt"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3Obf";


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/spot/websocket/account \.json$
// module id = 3Obf
// module chunks = 3